// import React from "react";

// const sizeClasses = {
//   sm: "pr-3 py-1.5",
//   md: "pr-3 py-2",
//   lg: "pr-4 py-2.5",
//   xl: "pr-5 py-3",
// };

// const fontSizeClasses = {
//   sm: "text-[12px]",
//   md: "text-[14px]",
//   lg: "text-[16px]",
//   xl: "text-[18px]",
// };

// const iconSizeClasses = {
//   sm: "text-[18px]",
//   md: "text-[20px]",
//   lg: "text-[24px]",
//   xl: "text-[26px]",
// };

// const CustomSearch = ({
//   placeholder = "Search...",
//   size = "md",
//   value,
//   onChange,
//   rounded = "rounded",
// }) => {
//   return (
//     <div
//       className={`flex items-center border border-gray-300 hover:border-primary focus-within:border-primary bg-white ${sizeClasses[size]} ${rounded}`}
//     >
//       <span
//         className={`material-icons text-gray-500 px-2 ${iconSizeClasses[size]}`}
//       >
//         search
//       </span>
//       <input
//         type="text"
//         value={value}
//         onChange={(e) => onChange(e.target.value)}
//         placeholder={placeholder}
//         className={`w-full outline-none bg-transparent ${fontSizeClasses[size]}`}
//       />
//     </div>
//   );
// };

// export default CustomSearch;

import React from "react";

const sizeClasses = {
  xs: "pr-0 py-0.5",
  "xs-sm": "pr-0 py-1",
  sm: "pr-0 py-1.5",
  md: "pr-0 py-2",
  lg: "pr-0 py-2.5",
  xl: "pr-0 py-3",
};

const fontSizeClasses = {
  xs: "text-[12px]",
  "xs-sm": "text-[12px]",

  sm: "text-[12px]",
  md: "text-[14px]",
  lg: "text-[16px]",
  xl: "text-[18px]",
};

const iconSizeClasses = {
  xs: "!text-[14px]",
  "xs-sm": "!text-[16px]",
  sm: "!text-[18px]",
  md: "!text-[20px]",
  lg: "!text-[24px]",
  xl: "!text-[26px]",
};

const CustomSearch = ({
  value,
  onChange,
  placeholder = "Search...",
  size = "md",
  rounded = "rounded",
  closeBtn = false,
  disabled = false,
  shadow = false,
  keyname,
  ...rest
}) => {
  return (
    <div
      className={`flex items-center border border-gray-300 hover:border-primary focus-within:border-primary bg-white  ${
        shadow ? "border-gray-50 inputShadow" : "border-gray-300"
      } ${sizeClasses[size]} ${rounded} relative`}
      {...rest}
    >
      {/* Search Icon */}
      <span
        className={`material-icons text-gray-500 px-2 ${iconSizeClasses[size]}`}
      >
        search
      </span>

      {/* Input Field */}
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(keyname, e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className={`w-full outline-none bg-transparent ${fontSizeClasses[size]}`}
      />

      {/* Clear (✖) Button - Shown only when there is a value */}
      <div className="w-7 flex justify-center items-center">
        {value && closeBtn && (
          <span
            className={`material-icons text-gray-500 px-2 cursor-pointer ${iconSizeClasses[size]}`}
            onClick={() => onChange(keyname, "")}
            size={size}
          >
            close
          </span>
        )}
      </div>
    </div>
  );
};

export default CustomSearch;
